export default (initialPlan) => ({
    currentIndex: 1,
    plansPerPage: 3,
    totalPlans: 0,
    plans: [],
    headings: [],
    table: '',

    async fetchPlans() {
        try {
            const response = await fetch(`/wp-json/plans/v1/plan?plan=${initialPlan}`);
            const data = await response.json();
            this.plans = data.plans;
            this.headings = data.headings;
            this.totalPlans = data.plans.length;

            this.initializeTable();
        } catch (error) {
        }
    },

    init() {
        this.setPlansPerPage();
        this.fetchPlans();
    },

    startSwipe(event) {
        this.startX = event.touches[0].clientX;
        this.startY = event.touches[0].clientY;
    },
    trackSwipe(event) {
    },
    endSwipe(event) {
        const endX = event.changedTouches[0].clientX;
        const endY = event.changedTouches[0].clientY;

        const deltaX = endX - this.startX;
        const deltaY = endY - this.startY;

  
        const threshold = 50;

        if (Math.abs(deltaX) > threshold) {
            if (deltaX > 0) {
                // User swiped right
                this.moveLeft();
            } else {
                // User swiped left
                this.moveRight();
            }
        }
    },

    setPlansPerPage() {
        if (window.innerWidth < 600) {
            // Mobile
            this.plansPerPage = 1;
        } else if (window.innerWidth < 1024) {
            // Tablet
            this.plansPerPage = 2;
        } else {
            // Desktop
            this.plansPerPage = 3;
        }
    },

    initializeTable() {
        const start = (this.currentIndex - 1) * this.plansPerPage;
        const end = start + this.plansPerPage;
        const visiblePlans = this.plans.slice(start, end);

        // find the max number of items in any plan
        const maxItems = Math.max(...visiblePlans.map(plan => Object.keys(plan).length));

        // create arrays for each row
        const rows = Array.from({ length: maxItems }, () => []);

        // add headings in the first column
        Object.values(this.headings).forEach((heading, index) => {
            rows[index].push(`<th class="${heading.type}" >${heading.label}</th>`);
        });

        // populate rows with plan data
        visiblePlans.forEach(plan => {
            Object.entries(plan).forEach(([key, value], index) => {
                rows[index].push(`<td>${value}</td>`);
            });
        });

        // join rows
        const rowshtml = rows.map(row => `<tr>${row.join('')}</tr>`).join('');

        this.table = `
            <table>
                <tbody>
                    ${rowshtml}
                </tbody>
            </table>
        `;
    },

    moveLeft() {
        if (this.currentIndex > 1) {
            this.currentIndex--;
            this.initializeTable();
        }
    },

    moveRight() {

        if ((this.currentIndex - 1) * this.plansPerPage + this.plansPerPage < this.plans.length) {
            this.currentIndex++;
        }
        this.initializeTable();
    },


    disableRightButton() {
        return this.currentIndex * this.plansPerPage >= this.totalPlans;
    },

});
